import { render, staticRenderFns } from "./site-setup-area-browser.component.vue?vue&type=template&id=fe83b760"
import script from "./site-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-area-browser.component.vue?vue&type=style&index=0&id=fe83b760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports